import { render, staticRenderFns } from "./PageManageCategory.vue?vue&type=template&id=5327447e&"
import script from "./PageManageCategory.vue?vue&type=script&lang=js&"
export * from "./PageManageCategory.vue?vue&type=script&lang=js&"
import style0 from "./PageManageCategory.vue?vue&type=style&index=0&id=5327447e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports